import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generateProductCode } from '../services/productsService';
import { searchRelatedProducts } from '../services/productsService';
import { validateProduct } from '../validations/productValidation';
import { AsyncPaginate } from 'react-select-async-paginate';

export default function AddProductModal({
  isOpen,
  onClose,
  handleAddProductSubmit,
  specificationUnits,
  productUnits,
  origins,
  productCategories,
  processCategories,
  processLocations,
  LOB,
  FBZ,
  isFBZ,
}) {
  const { t } = useTranslation('Products');

  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [realtedProducts, setRealtedProducts] = useState([]);
  const [formData, setFormData] = useState({
    code: '',
    category: null,
    process_category: null,
    name: '',
    origin: null,
    specification_value: '',
    specification_unit: null,
    product_value: '',
    product_unit: null,
    process_location: null,
    LOB: LOB,
    FBZ: FBZ,
    net_weight: '',
    related_product: null,
    conversion_rate: '',
  });
  const resetForm = (e) => {
    setFormData({
      code: '',
      category: null,
      process_category: null,
      name: '',
      origin: null,
      specification_value: '',
      specification_unit: null,
      product_value: '',
      product_unit: null,
      process_location: null,
      LOB: LOB,
      FBZ: FBZ,
      net_weight: '',
      related_product: null,
      conversion_rate: '',
    });
  };
  console.log('formdata', formData);
  const relatedProductsLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const per_page = 50;
    const query = { page, per_page, search: inputValue };

    const productsResponse = await searchRelatedProducts(query);

    const newOptions = productsResponse.products.map((product) => ({
      value: product.id,
      label: `${product.name} | (${product.code})`,
      productObject: product,
    }));

    return {
      options: newOptions,
      hasMore:
        productsResponse.pagination.current_page <
        productsResponse.pagination.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  useEffect(() => {
    const modalElement = document.getElementById('new-products');
    const modalInstance = new window.bootstrap.Modal(modalElement, {
      backdrop: 'static',
      keyboard: false,
    });

    if (isOpen) {
      modalInstance.show();
    } else {
      modalInstance.hide();
      // resetForm();
    }
    return () => {
      modalInstance.hide();
      // resetForm();
    };
  }, [isOpen]);
  useEffect(() => {
    if (isFBZ && isOpen) {
      const fetchCode = async () => {
        const response = await generateProductCode();
        if (response.success) {
          setFormData((prevData) => ({
            ...prevData,
            code: response.code,
          }));
        }
      };

      fetchCode();
    }
  }, [isOpen, isFBZ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleCategoryChange = (e) => {
    const selectedCategory = productCategories.find(
      (category) => category.id === e.target.value
    );
    const selectedProcessCategory = processCategories.find(
      (category) => category.id === selectedCategory.process_category_id
    );
    const selectedProcessLocation = processLocations.find(
      (processLocation) =>
        processLocation.id === selectedCategory.process_location_id
    );

    setFormData((prevData) => ({
      ...prevData,
      category: selectedCategory || null,
      process_category: selectedProcessCategory || null,
      process_location: selectedProcessLocation || null,
    }));
  };
  // const handleProcessCategoryChange = (e) => {
  //   const selectedProcessCategory = processCategories.find(
  //     (category) => category.id === e.target.value
  //   );

  //   setFormData((prevData) => ({
  //     ...prevData,
  //     process_category: selectedProcessCategory || null,
  //   }));
  // };
  const handleOriginChange = (e) => {
    const selectedOrigin = origins.find(
      (origin) => origin.id === e.target.value
    );

    setFormData((prevData) => ({
      ...prevData,
      origin: selectedOrigin || null,
    }));
  };
  const handleSpecificationUnitChange = (e) => {
    const selectedSpecificationUnit = specificationUnits.find(
      (specificationUnit) => specificationUnit.id === e.target.value
    );

    setFormData((prevData) => ({
      ...prevData,
      specification_unit: selectedSpecificationUnit || null,
    }));
  };

  const handleProductUnitChange = (e) => {
    const selectedProductUnit = productUnits.find(
      (productUnit) => productUnit.id === e.target.value
    );

    setFormData((prevData) => ({
      ...prevData,
      product_unit: selectedProductUnit || null,
    }));
  };
  // const handleProcessLocationChange = (e) => {
  //   const selectedProcessLocation = processLocations.find(
  //     (processLocation) => processLocation.id === e.target.value
  //   );

  //   setFormData((prevData) => ({
  //     ...prevData,
  //     process_location: selectedProcessLocation || null,
  //   }));
  // };
  const handleRelatedProductChange = (selectedOption) => {
    const selectedRelatedProduct = selectedOption?.productObject || null;
    console.log('selectedOption', selectedRelatedProduct);
    setFormData((prevData) => ({
      ...prevData,
      related_product: selectedRelatedProduct,
    }));
  };

  const handleSubmit = async () => {
    console.log('form data:', formData);
    let submitData = { ...formData };
    if (isFBZ) {
      delete submitData.net_weight;
    } else {
      delete submitData.related_product;
      delete submitData.conversion_rate;
    }

    const validationResult = await validateProduct(submitData);
    if (!validationResult) {
      return;
    }
    setLoading(true);
    if (handleAddProductSubmit) {
      const response = await handleAddProductSubmit(submitData);
      if (response?.success) {
        resetForm();
      }
    }
    setLoading(false);
  };

  return (
    <div
      className="modal fade"
      id="new-products"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="staticBackdropLabel">
              {t('ADDNEWPRODUCT')}
            </h1>
            <button
              type="button"
              className="btn-close"
              // data-bs-dismiss="modal"
              // aria-label="Close"
              onClick={() => {
                resetForm();
                onClose('add');
              }}
            ></button>
          </div>
          <div className="modal-body">
            <section className="first">
              <div className="row">
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    {isFBZ ? (
                      <input
                        className="did-floating-input"
                        type="text"
                        name="code"
                        value={formData.code}
                        onChange={handleChange}
                        disabled
                      />
                    ) : (
                      <input
                        className="did-floating-input"
                        type="number"
                        name="code"
                        value={formData.code}
                        onChange={handleChange}
                      />
                    )}
                    <label className="did-floating-label">
                      {t('PRODUCTCODE')} <span className="required">*</span>
                    </label>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <select
                      key={isOpen ? 'open' : 'close'} //for force reset previouly selected value
                      className="did-floating-select"
                      name="category"
                      value={formData?.category?.id}
                      onChange={handleCategoryChange}
                    >
                      <option value="">{t('SELECTCATEGORY')}</option>

                      {productCategories.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                    <label className="did-floating-label">
                      {t('CATEGORY')} <span className="required">*</span>
                    </label>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <input
                      className="did-floating-input"
                      type="text"
                      name="process_category"
                      value={formData?.process_category?.name || ''}
                      disabled
                    />
                    <label className="did-floating-label">
                      {t('PROCESSCATEGORY')} <span className="required">*</span>
                    </label>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <input
                      className="did-floating-input"
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    <label className="did-floating-label">
                      {t('PRODUCTNAME')} <span className="required">*</span>
                    </label>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <select
                      key={isOpen ? 'open' : 'close'}
                      className="did-floating-select"
                      name="origin"
                      value={formData?.origin?.id}
                      onChange={handleOriginChange}
                    >
                      <option value="">{t('SELECTORIGIN')}</option>
                      {origins.map((origin) => (
                        <option key={origin.id} value={origin.id}>
                          {origin.name}
                        </option>
                      ))}
                    </select>
                    <label className="did-floating-label">
                      {t('ORIGIN')} <span className="required">*</span>
                    </label>
                  </div>
                </div>
                {!isFBZ && (
                  <div className="col-sm-4">
                    <div className="did-floating-label-content">
                      <input
                        className="did-floating-input"
                        type="text"
                        name="net_weight"
                        value={formData.net_weight}
                        onChange={handleChange}
                      />
                      <label className="did-floating-label">
                        {t('NETWEIGHT')} <span className="required">*</span>
                      </label>
                    </div>
                  </div>
                )}
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <input
                      className="did-floating-input"
                      type="number"
                      name="specification_value"
                      value={formData.specification_value}
                      onChange={handleChange}
                      step=".01"
                    />
                    <label className="did-floating-label">
                      {t('SPECIFICATIONVALUE')}{' '}
                    </label>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <select
                      key={isOpen ? 'open' : 'close'}
                      className="did-floating-select"
                      name="specification_unit"
                      value={formData?.specification_unit?.id}
                      onChange={handleSpecificationUnitChange}
                    >
                      <option value="">{t('SELECTSPECIFICATIONUNIT')}</option>
                      {specificationUnits.map((unit) => (
                        <option key={unit.id} value={unit.id}>
                          {unit.name}
                        </option>
                      ))}
                    </select>
                    <label className="did-floating-label">
                      {t('SPECIFICATIONUNIT')}{' '}
                    </label>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <input
                      className="did-floating-input"
                      type="number"
                      name="product_value"
                      value={formData.product_value}
                      onChange={handleChange}
                    />
                    <label className="did-floating-label">
                      {t('PRODUCTVALUE')} <span className="required">*</span>
                    </label>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <select
                      key={isOpen ? 'open' : 'close'}
                      className="did-floating-select"
                      name="product_unit"
                      value={formData?.product_unit?.id}
                      onChange={handleProductUnitChange}
                    >
                      <option value="">{t('SELECTPRODUCTUNIT')}</option>
                      {productUnits.map((unit) => (
                        <option key={unit.id} value={unit.id}>
                          {unit.name}
                        </option>
                      ))}
                    </select>
                    <label className="did-floating-label">
                      {t('PRODUCTUNIT')} <span className="required">*</span>
                    </label>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="did-floating-label-content">
                    <input
                      className="did-floating-input"
                      type="text"
                      name="process_location"
                      value={formData?.process_location?.name || ''}
                      disabled
                    />
                    <label className="did-floating-label">
                      {t('PROCESSLOCATION')} <span className="required">*</span>
                    </label>
                  </div>
                </div>
                {isFBZ && (
                  <>
                    <div className="col-sm-4">
                      <div className="did-floating-label-content edit-product-change change-width">
                        <AsyncPaginate
                          value={
                            formData.related_product
                              ? {
                                  value: formData.related_product.id,
                                  label: `${formData.related_product.name} | (${formData.related_product.code})`,
                                }
                              : null
                          }
                          loadOptions={relatedProductsLoadOptions}
                          onChange={handleRelatedProductChange}
                          placeholder={t('SEARCHANDSELECTRELATEDPRODUCT')}
                          isClearable
                          isLoading={loading}
                          additional={{
                            page: 1,
                          }}
                        />
                        {/* <label className="did-floating-label">
                          {t("RELATEDPRODUCTS")}
                        </label> */}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="did-floating-label-content">
                        <input
                          className="did-floating-input"
                          type="text"
                          name="conversion_rate"
                          value={formData.conversion_rate}
                          onChange={handleChange}
                        />
                        <label className="did-floating-label">
                          {t('CONVERSIONRATE')}
                        </label>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="bottom-button">
                <button
                  className="cancel"
                  onClick={() => {
                    resetForm();

                    onClose('add');
                  }}
                >
                  {t('CANCEL')}
                </button>
                <button
                  className={`save ${loading ? 'disable-btn' : ''}`}
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {t('ADD')}
                  {/* {loading?(t("LOADING")+"..."):t("ADD")} */}
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
